import React from "react";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";
import Creation from "./Creation";

const CreateTemplate = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs
        noTranslate
        alarm
        pageName={t({ defaultMessage: "报警模板" })}
      />
      <Creation />
    </>
  );
};

export default CreateTemplate;
